<!-- <p>confirmation-dialog works!</p> -->
<div class="confirmation flex flex-col gap-8">
  <div class="confirmation-header flex justify-between">
    <div class="font-bold text-base">Confirmation</div>
    <mat-icon mat-dialog-close class="pointerCursor">close</mat-icon>
  </div>
  <div class="confirmation-content flex justify-start text-black">
    <div>
      Are you sure you want to delete the
      <b>{{ +questionData.isQuestion ? " question " : " section " }}</b
      >?
    </div>
  </div>
  <div class="confirmation-btn-section flex justify-end">
    <div class="confirmation-btn-holder flex gap-8 text-white font-bold">
      <div
        [mat-dialog-close]="questionData"
        class="confirmation-btn-section-btns flex gap-2 items-center"
      >
        <mat-icon>check</mat-icon>
        <span class="confirmation-btn-section-btns p-2.5 rounded-lg"
          >Delete</span
        >
      </div>
      <div
        mat-dialog-close
        class="confirmation-btn-section-btns flex gap-4 items-center"
      >
        <mat-icon>close</mat-icon>
        <span class="confirmation-btn-section-btns p-2.5 rounded-lg">No</span>
      </div>
    </div>
  </div>
</div>
